import React, { useState, useContext, useEffect } from 'react';
import {
 Table, Modal, Col, Row,
} from 'react-bootstrap';
import toast from 'react-hot-toast';
import PropTypes from 'prop-types';
import { FaFileExcel } from 'react-icons/fa';
import { Button } from '../../../shared/components/Button';
import AddCurrencyRateForm from './AddCurrencyRateForm';
import { AuthContext } from '../../../context/AuthContext';
import generateCurrencyExcel from './CurrencyExcel';


const CurrencyTable = ({ currencyRefresh, setCurrencyRefresh }) => {
    const [currencyData, setCurrencyData] = useState([]);
    const { apiGlobal } = useContext(AuthContext);
    const [currencyDataEdit, setCurrencyDataEdit] = useState({
      id: '',
      rate: '',
      modalOpen: false,
    });



    const fetchCurrencyRates = async () => {
      try {
        const url = await fetch(`${apiGlobal}/country_currency_data.php`, {
          method: 'post',
        });
        const response = await url.json();
        if (response.status && response.message === 'Success') {
          setCurrencyData(response?.data || []);
        } else {
          console.error('Error fetching currency rates:', response.message);
          setCurrencyData([]);
        }
      } catch (error) {
        console.error('Error fetching currency rates:', error);
      }
    };

    useEffect(() => {
      fetchCurrencyRates();
    }, [currencyRefresh]);


    const handleEditRate = async (e) => {
      e.preventDefault();
       if (!currencyDataEdit.rate) {
        alert('Please enter a new rate');
        return;
       }
       if (!currencyDataEdit.id) {
        alert('Please select a currency to edit');
        return;
       }

       const body = new FormData();
        body.append('id', currencyDataEdit.id);
        body.append('rate', currencyDataEdit.rate);
      try {
           const url = await fetch(`${apiGlobal}/country_currency_update.php`, {
            method: 'post',
            body,
           });
           const response = await url.json();
           if (response.status && response.message === 'Rate updated successfully.') {
            setCurrencyRefresh(prev => !prev);

            setCurrencyDataEdit({
              rate: '',
              id: '',
              modalOpen: false,
            });
            toast.success('Rate updated successfully');
          } else {
            console.error('Error updating currency rate:', response.message);
            setCurrencyDataEdit({
              rate: '',
              id: '',
              modalOpen: false,
            });
          }
      } catch (error) {
        console.error('Error updating currency rate:', error);
      }
    };

    return (
      <div>
        <Button
          variant="outline-primary"
          size="sm"
          onClick={() => generateCurrencyExcel(currencyData)}
        >
          <FaFileExcel />  Downloud Excel
        </Button>
        <Table
          responsive
          style={{
          backgroundColor: '#f9f9f9',
          borderRadius: '8px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        }}
        >
          <thead className="bg-success" style={{ color: 'white', textAlign: 'center' }}>
            <tr>
              <th>#</th>
              <th>Country</th>
              <th>Currency</th>
              <th>New Rate</th>
              <th>Old Rate</th>
              <th>Remark</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currencyData.map((item, index) => (
              <tr
              // eslint-disable-next-line react/no-array-index-key
                key={index}
                style={{
                backgroundColor: '#ffffff',
                textAlign: 'center',
              }}
              >
                <td>{index + 1}</td>
                <td>{item.country_name}</td>
                <td>{item.currency_name}</td>
                <td>{item.rate}</td>
                <td>{item.old_rate}</td>
                <td>
                  {(() => {
              const rateDiff = item.rate - item.old_rate;

              if (rateDiff > 0) {
                return (
                  <span style={{ color: 'green' }}>
                    <i className="fa-solid fa-arrow-up" /> Increase by {rateDiff.toFixed(2)}
                  </span>
                );
              } if (rateDiff < 0) {
                return (
                  <span style={{ color: 'red' }}>
                    <i className="fa-solid fa-arrow-down" /> Decrease by {Math.abs(rateDiff).toFixed(2)}
                  </span>
                );
              } 
                return (
                  <span style={{ color: 'gray' }}>
                    <i className="fa-solid fa-minus" /> No change
                  </span>
                );
            })()}

                </td>
                
                <td>

                  <Button 
                    variant="outline-primary"
                    size="sm"
                    onClick={() => setCurrencyDataEdit({
                      id: item.id,
                      rate: item.rate,
                      modalOpen: true,
                    })}
                    
                  >
                    Edit
                  </Button>
                </td>


              </tr>
  ))}
          </tbody>

        </Table>
        {/* Modal for Edit Currency Rate */}
        <Modal
          show={currencyDataEdit.modalOpen}
          onHide={() => setCurrencyDataEdit({
            id: '',
            rate: '',
            modalOpen: false,
          })}
          centered
          size="md"
          backdrop="static" // Prevent clicking outside the modal to close it
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Update Currency Rate</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <AddCurrencyRateForm /> */}
            <form onSubmit={handleEditRate}>
              <Row>
                <Col md={8}>
                  {/* <label htmlFor="currency-rate" className="form-label fw-semibold">
                    New Currency Rate
                  </label> */}
                  <input
                    type="number"
                    value={currencyDataEdit.rate}
                    onChange={e => setCurrencyDataEdit({ ...currencyDataEdit, rate: e.target.value })}
                    className="form-control"
                    id="currency-rate"
                    name="currency-rate"
                    placeholder="Enter new rate"
                    required
                  />
                </Col>
                <Col md={4} className="mt-6">
                  <Button
                    variant="primary"
                    size="sm"
                    type="submit"

                  >
                    <i className="fa-solid fa-pen-to-square me-2" />Edit Rate
                  </Button>
                </Col>
              </Row>
            </form>
          </Modal.Body>
        </Modal>
      </div>
  );
};

CurrencyTable.propTypes = {
  currencyRefresh: PropTypes.bool.isRequired,
  setCurrencyRefresh: PropTypes.func.isRequired,
};

export default CurrencyTable;
